export enum GameRarity {
    common = 'common',
    epic = 'epic',
    legendary = 'legendary',
    rare = 'rare',
    uncommon = 'uncommon',
}
